import $ from 'jquery';
import { VIDEO_TYPE } from '../constants';
/** ***
 ** Common function for validate data
 *****/

/**
 * validUrl
 * using for validate url
 * @param {*} val
 */
export function validUrl(val) {
  const rule = /^https?:\/\/[\w/:%#$&?()~.=+-]+/gm;
  return rule.test(val);
}

/**
 * validAutoCode
 * Using for validate code number
 * @param {*} code
 */
export function validAutoCode(code) {
  const rule = /^[a-zA-Z0-9]+$/;
  return rule.test(code);
}

// sprint_20230731_tma START
/**
 * validSaleCd
 * Using for validate sale cd
 * @param {*} code
 */
export function validSaleCd(code) {
  const rule = /^[0-9-]*$/;
  return rule.test(code);
}
// sprint_20230731_tma END

/**
 * validNumFormat
 * Using for validate number
 * @param {*} val
 */
export function validNumFormat(val) {
  const rule = /^[0-9]+$/;
  return rule.test(val);
}

/**
 * validNumFormat
 * Using for validate number, do not accept zero
 * @param {*} val
 */
export function validNumNonZeroFormat(val) {
  const rule = /^\d*[1-9]\d*$/;
  return rule.test(val);
}

/**
 * validCorrectAnswers
 * Using for validate correct answers without having two underscores or /
 * @param {*} val
 */
export function validCorrectAnswers(val) {
  const rule = /[_][_]+|[/]+/;
  return rule.test(val);
}

/**
 * validIdFormat
 * Using for validate Identification id
 * @param {*} id
 */
export function validIdFormat(id) {
  const rule = /^[a-zA-Z0-9_]+$/;
  return rule.test(id);
}

/**
 * validIdFormat2
 * Using for validate Identification id contain hyphen character
 * @param {*} id
 */
export function validIdFormat2(id) {
  const rule = /^[a-zA-Z0-9_-]+$/;
  return rule.test(id);
}

/**
 * validIdFormat
 * Using for validate Identification id
 * @param {*} id
 */
export function validLoginIdFormat(id) {
  const rule = /^[a-zA-Z0-9_\\.\-@]+$/;
  return rule.test(id);
}

// Step 7.0 #6 START
/**
 * validUserLoginIdFormat
 * Using for validate User Login Identification id
 * @param {*} id
 */
export function validUserLoginIdFormat(id) {
  const rule = /^[a-zA-Z0-9._@\-!#$%&'*+/=?^`{|}~]+$/; 
  return rule.test(id);
}
// Step 7.0 #6 END

/**
 * validInvoiceNumber
 * Using for validate invoice number
 * @param {*} id
 */
export function validInvoiceNumber(num) {
  const rule = /^[0-9-]+$/;
  return rule.test(num);
}

/**
 * validPasswordFormat
 * Using for validate password
 * @param {*} pass
 */
export function validPasswordFormat(pass) {
  const rule = /^[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]+$/;
  return rule.test(pass);
}

/**
 * validPhoneNumber
 * Using for validate phone number
 * @param {*} phone
 */
export function validPhoneNumber(phone) {
  const rule = /^[0-9-]+$/;
  return rule.test(phone); // sprint_20230403 #4
}

/**
 * validEmail
 * Using for validate email
 * @param {*} mail
 */
export function validEmail(mail) {
  const rule = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return rule.test(mail);
}

/**
 * validRealNumber
 * using for validate number is real number
 * @param {*} number
 */
export function validRealNumber(number) {
  const rule = /^([0-9]*|(0|[1-9]+)\.[0-9]*)$/;
  return rule.test(number);
}

/**
 * validCouseBoxIdFormat
 * using for valid courseId, boxId format
 * @param {*} id
 */
export function validCouseBoxIdFormat(id) {
  const rule = /^[a-zA-Z0-9]*$/;
  return rule.test(id);
}

/**
 * validDrillQuestionSetting
 * using for valid drill question setting
 * @param {*} id
 */
export function validDrillQuestionSetting(id) {
  const rule = /^[a-zA-Z0-9/&()]+$/;
  return rule.test(id);
}

/**
 * validUrl
 * using for validate url
 * @param {*} val
 */
export function validRequired(val) {
  const rule = /^\S+$/;
  return rule.test(val);
}

/**
 * Validate type of image
 * @param {*} type
 */
export function validImageFile(fileName) {
  const type = fileName.split('.').pop();
  const typeConvert = type.toLowerCase();
  const imgType = ['gif', 'jpeg', 'png', 'jpg'];
  if ($.inArray(typeConvert.trim(), imgType) < 0) {
    return false;
  }
  return true;
}

/**
 * Validate type of image and size course
 * @param {*} type
 */
export function validImageFileAndSizeCourse(fileName, fileSize) {
  const kiloByte = 1024;
  const type = fileName.split('.').pop();
  const typeConvert = type.toLowerCase();
  const maxImageSize = 5 * kiloByte * kiloByte;
  const imgType = ['gif', 'jpeg', 'png', 'jpg'];
  if ($.inArray(typeConvert.trim(), imgType) < 0 || fileSize > maxImageSize) {
    return false;
  }
  return true;
}

/**
 * Validate number range
 * @param {*} type
 */
export function validNumberRange(number, minNum, maxNum) {
  const rule = /^[0-9]+$/;
  number = parseInt(number, 10);
  return rule.test(number) && number >= parseInt(minNum, 10) && number <= parseInt(maxNum, 10);
}

/**
 * validVideoUploadSize
 * using for valid video uploaded size
 * @param {*} fileSize
 */
export function validVideoUploadSize(fileSize) {
  const maxVideoSize = 10 * 1024 * 1024 * 1024; // #6739
  if (fileSize <= maxVideoSize) {
    return true;
  }
  return false;
}

/**
 * validConfigFileUploadSize
 * using for valid config file uploaded size
 * @param {*} fileSize
 */
export function validConfigFileUploadSize(fileSize) {
  const maxConfigFileSize = 2 * 1024 * 1024 * 1024;
  if (fileSize <= maxConfigFileSize) {
    return true;
  }
  return false;
}

/**
 * validDocumentUploadSize
 * using for valid document uploaded size
 * @param {*} fileSize
 */
export function validDocumentUploadSize(fileSize) {
  const maxVideoSize = 2 * 100 * 1024 * 1024;
  if (fileSize <= maxVideoSize) {
    return true;
  }
  return false;
}

export function validThumbnailUploadSize(fileSize) {
  const maxSize = 5 * 1024 * 1024;
  if (fileSize < maxSize) {
    return true;
  }
  return false;
}

/**
 * validQuestionAnswer
 * using for valid question answer
 * @param {*} answerInfo
 */
export function validQuestionAnswer(answerInfo) {
  const check = Object.prototype.toString.call(answerInfo) === '[object Array]';
  // if answerInfo empty return validate fail
  if (!check) {
    return false;
  }
  // sort answerInfo before check
  const answerInfoSorted = sortAnswerInfo(answerInfo);
  if (!answerInfoSorted || !answerInfoSorted.length) {
    return false;
  }
  if (!answerInfoSorted[0] || parseInt(answerInfoSorted[0], 10) !== 1) {
    return false;
  }
  let number = -1;
  for (let i = 0; i < answerInfoSorted.length; i++) {
    if (number != -1 && (answerInfoSorted[i] - number != 1)) {
      return false;
    }
    number = answerInfoSorted[i];
  }
  return true;
}

export function minMultiAnswer(answerList) {
  if (!answerList || !answerList.length) {
    return false;
  } else if (answerList && answerList.length && answerList.length < 2) {
    return false;
  }
  return true;
}

export function sortAnswerInfo(answerInfo) {
  const check = Object.prototype.toString.call(answerInfo) === '[object Array]';
  if (check) {
    answerInfo = answerInfo.sort((a, b) => {
      if (parseInt(a, 10) < parseInt(b, 10)) {
        return -1;
      } else if (parseInt(a, 10) > parseInt(b, 10)) {
        return 1;
      }
      return 0;
    });
    return answerInfo;
  }
  return [];
}

/**
 * validSelectiveSingleQuestionAnswer
 * using for valid Selective Single question answer
 * @param {*} answerInfo
 */
export function validSelectiveSingleQuestionAnswer(answerInfo) {
  const check = Object.prototype.toString.call(answerInfo) === '[object Array]';
  if (!check) {
    return false;
  }
  if (!answerInfo || !answerInfo.length || answerInfo.length !== 1) {
    return false;
  }
  return true;
}

/**
 * validItemListForCourseEnd
 * using for valid item list for course end
 * @param {*} itemList
 */
export function validItemListForCourseEnd(itemList) {
  const check = Object.prototype.toString.call(itemList) === '[object Array]';
  if (check) {
    if (itemList.length > 0) {
      return true;
    }
    return false;
  }
  return false;
}

/**
 * validateVideoType
 * using for valid video file type
 * @param {*} fileType
 */
export function validateVideoType(fileType) {
  if (VIDEO_TYPE.indexOf(fileType.split('.').pop().toLowerCase()) > -1) {
    return true;
  }
  return false;
}

/**
 * validUploadMinSize
 * using for valid file uploaded min size
 * @param {*} fileSize
 */
export function validUploadMinSize(fileSize) {
  const minSize = 0;
  if (minSize < fileSize) {
    return true;
  }
  return false;
}
// #7287 START
/**
 * isBundleScript
 * using to check if script is bundle script
 * @param {*} script
 * @returns
 */
export function isBundleScript(script) {
  const rule = /static\/js\/\w*main.\w*.js$/;
  return rule.test(script);
}
// #7287 END

// Step SAML START
/**
 * Validate type of xml and size
 * @param {*} fileName
 * @param {*} fileSize
 */
export function validXmlFileAndSize(fileName, fileSize) {
  const kiloByte = 1024;
  const type = fileName.split('.').pop();
  const typeConvert = type.toLowerCase();
  const maxImageSize = 5 * kiloByte * kiloByte;
  if (typeConvert !== 'xml' || fileSize > maxImageSize) {
    return false;
  }
  return true;
}
// Step SAML END

// sprint_20230508_#29 START
export function isRedirectContractUrl(path) {
  const rule = /\?direct_contract=\w*$/;
  return rule.test(path);
}
// sprint_20230508_#29 END

// Step 11.0.0 START
/**
 * validLoginIdSuFormat
 * Using for validate login id of SU
 * @param {*} id
 */
export function validLoginIdSuFormat(id) {
  const rule = /^$|^[a-zA-Z0-9_!#$%&\.'*+/=?`{|}~^-]+(?:\.[a-zA-Z0-9_!#$%&\.'*+/=?`{|}~^-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return rule.test(id);
}
// Step 11.0.0 END
